export const getters = {
  list: state => state.list,
  expire_amount: state => state.expire_amount,
  model: state => state.model,
  columns: state => state.columns,
  columnsForStuckBunk: state => state.columnsForStuckBunk,
  filter: state => state.filter,
  pagination: state => state.pagination,
  sort: state => state.sort,
  inventory: state => state.inventory
};